export const hasValue = (value) => (
  value !== null && value !== undefined && value !== 'null' && value !== ''
);

export const dateFormatter = (shortDate) => {
  if (!hasValue(shortDate)) {
    return null;
  } else {
    let mydate = new Date(shortDate);
    var month = ['January',
                 'February',
                 'March',
                 'April',
                 'May',
                 'June',
                 'July',
                 'August',
                 'September',
                 'October',
                 'November',
                 'December',
               ][mydate.getMonth()];
    let str = month + ' ' + mydate.getFullYear();
    return (str);
  }
};

export const dateRange = (startDate, endDate) => {
  const start = startDate.split('-');
  const end = endDate.split('-');
  const startYear = parseInt(start[0]);
  const endYear = parseInt(end[0]);
  let dates = [];
  for(let i = startYear; i <= endYear; i++) {
    const endMonth = i !== endYear ? 11 : parseInt(end[1]) - 1;
    const startMon = i === startYear ? parseInt(start[1])-1 : 0;
    for(let j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
      const month = j+1;
      const displayMonth = month < 10 ? '0'+month : month;
      dates.push([i, displayMonth, '01'].join('-'));
    }
  }
  return dates;
};

export const futureDate = (shortDate) => {
  if (!hasValue(shortDate)) {
    return false;
  }
  const operationDate = new Date(shortDate);
  const today = new Date();
  if (today < operationDate) {
    return true;
  }
  return false;
};

export const delayTodayDateByMonths = (months) => {
  const date = new Date();
  date.setMonth(date.getMonth() + months);
  return date;
}
